import React from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { FINAL_CTA } from "@/constants/testIds";
import { useT } from "@/i18n";

export default function FinalCTA({ heading, lede, ctaLabel, ctaTo = "/contact" }) {
  const t = useT();
  return (
    <section data-testid={FINAL_CTA.root} className="relative overflow-hidden border-t border-white/10">
      <div className="absolute inset-0 bg-gradient-to-br from-[#071A35] via-[#0C2549] to-[#071A35]" />
      <div className="absolute -top-32 left-1/2 -translate-x-1/2 w-[640px] h-[640px] rounded-full bg-[#0057FF] opacity-25 blur-[120px]" />
      <div className="absolute inset-0 nx-grid-bg opacity-40" />
      <div className="relative nx-container py-24 md:py-32 text-center">
        <div className="nx-mono text-xs uppercase tracking-[0.32em] text-[#38D8FF] mb-5">
          / {t.finalCta.eyebrow}
        </div>
        <h2 className="nx-heading text-4xl sm:text-5xl lg:text-6xl font-bold leading-tight max-w-4xl mx-auto">
          {heading || t.finalCta.heading}
        </h2>
        <p className="mt-6 text-base sm:text-lg text-white/70 max-w-2xl mx-auto leading-relaxed">
          {lede || t.finalCta.lede}
        </p>
        <div className="mt-10 flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to={ctaTo}
            data-testid={FINAL_CTA.button}
            className="inline-flex items-center gap-2 px-7 py-4 rounded-md bg-[#0057FF] hover:bg-[#2F80FF] text-white font-medium text-sm transition-all nx-cta-glow"
          >
            {ctaLabel || t.finalCta.button}
            <ArrowUpRight className="w-4 h-4" />
          </Link>
          <Link
            to="/services"
            className="inline-flex items-center gap-2 px-7 py-4 rounded-md border border-white/20 hover:border-[#38D8FF] hover:text-white text-white/85 text-sm font-medium transition-all"
          >
            {t.finalCta.exploreBtn}
          </Link>
        </div>
      </div>
    </section>
  );
}
